<template>
    <div class="category-box">
        <a :href="`/category/${category.slug}`">
            <div style="height: 170px; overflow: hidden;">
                <img :src="category.logo ? category.logo : '/images/category-changed.png'"
                     :alt="category.name"
                     style="width: 100%;"
                />
            </div>
            <h3>
                {{ category.name }}
            </h3>
        </a>
    </div>
</template>

<script>
    export default {
        name: "CategoryCard",
        props: {
            category: {
                type: Object,
                default: function () {
                    return {
                        slug: '',
                        logo: '',
                        name: ''
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>